const columns = (filters, companies = []) => {
  const baseFilters = [
    {
      value: 1,
      label: 'Consumer',
      text: 'Consumer',
    },
    {
      value: 2,
      label: 'Commercial',
      text: 'Commercial',
    },
  ];

  const companyFilters = companies.map((company) => ({
    value: company.id + 2,
    label: company.displayName,
    text: company.displayName,
  }));

  const allFilters = [...baseFilters, ...companyFilters];

  return [
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: 'Subject',
      dataIndex: 'subject',
      key: 'subject',
    },
    {
      title: 'Commercial/consumer',
      dataIndex: 'forCustomerCategoryId',
      key: 'forCustomerCategoryId',
      filters: allFilters,
      onFilter: (value, record) => record.forCustomerCategoryId === value,
      customRender: ({ value }) => {
        if (Number(value) === 2) return 'Commercial';
        if (Number(value) === 1) return 'Consumer';
        const company = companies.find((c) => c.id + 2 === Number(value));
        return company ? company.displayName : 'Consumer';
      },
    },
    {
      title: 'Type',
      dataIndex: 'type',
      key: 'type',
      filters,
      onFilter: (value, record) => (record.type || '').indexOf(value) === 0,
    },
    {
      title: 'Reminder',
      dataIndex: 'isReminder',
      key: 'reminder',
      customRender: ({ value }) => (value ? 'Yes' : 'No'),
    },
    {
      title: 'Default',
      dataIndex: 'isDefault',
      key: 'default',
      customRender: ({ value }) => (value ? 'Yes' : 'No'),
    },
    {
      title: 'Actions',
      dataIndex: 'actions',
      key: 'actions',
    },
  ];
};

export default columns;
